import { render } from "./AppNotificationModal.vue?vue&type=template&id=b765e12e&scoped=true"
import script from "./AppNotificationModal.vue?vue&type=script&lang=js"
export * from "./AppNotificationModal.vue?vue&type=script&lang=js"

import "./AppNotificationModal.vue?vue&type=style&index=0&id=b765e12e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b765e12e"]])

export default __exports__